module.exports = __webpack_public_path__ + "img/taobao.795228d9.png";